import { Component } from '@angular/core';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
    selector: 'app-communication-consent',
    templateUrl: './communication-consent.modal.html',
    styleUrls: ['./communication-consent.modal.scss'],
    standalone: false
})
export class CommunicationConsentModal {

    userEnableEmail = false;
    userEnableSms = false;
    userEnableApp = false;
    userEnableWhatsApp = false;
    userEnablePhone = false;
    userEnablePostal = false;

    constructor(private modalService: ModalService) {}

    acceptAll(): void {
        this.userEnableEmail = true;
        this.userEnableSms = true;
        this.userEnableApp = true;
        this.userEnableWhatsApp = true;
        this.userEnablePhone = true;
        this.userEnablePostal = true;
    }

    cancel(): void {
        this.modalService.dismiss(null, 'cancel', CommunicationConsentModalId);
    }

    save(): void {
        const channels = {
            email: this.userEnableEmail,
            sms: this.userEnableSms,
            app: this.userEnableApp,
            whatsapp: this.userEnableWhatsApp,
            call: this.userEnablePhone,
            postal: this.userEnablePostal,
        };
        this.modalService.dismiss({ channels }, 'save', CommunicationConsentModalId);
    }
}

export const CommunicationConsentModalId = 'COMMUNICATION_CONSENT_MODAL';
export const CommunicationConsentModalCss = 'communication-consent-modal';
